import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from 'Redux/axiosHelper'
import {
  OfficialConstraintPayload,
  OfficialConstraintResp,
} from 'types/league/officialConstraints'

// get all officials
const getAllOfficials = async (leagueId: string) => {
  const response = await axiosGet(`v1/leagues-official/step-11/${leagueId}`)
  return response.data
}
export const useGetAllOfficials = (leagueId: string) => {
  const officials = useQuery<OfficialConstraintResp[]>(
    ['get-league-officials-constraints'],
    () => (leagueId ? getAllOfficials(leagueId) : null),
    {
      enabled: false,
    },
  )
  return officials
}
// create new official
const createNewOfficail = async ({
  leagueId,
  payload,
}: {
  leagueId: string
  payload: OfficialConstraintPayload
}) => {
  const response = await axiosPost(
    payload,
    `v1/leagues-official/step-11/${leagueId}`,
  )
  return response.data
}

export const useCreateOfficial = () => {
  const queryClient = useQueryClient()
  return useMutation(createNewOfficail, {
    onSuccess: (newOfficial: OfficialConstraintResp) => {
      queryClient.setQueryData(
        ['get-league-officials-constraints'],
        (oldData: OfficialConstraintResp[] | undefined) => {
          if (!oldData) return []
          return [newOfficial, ...oldData]
        },
      )
    },
  })
}

// update officail
const updateOfficial = async ({
  officialId,
  payload,
}: {
  officialId: string
  payload: OfficialConstraintPayload
}) => {
  const response = await axiosPatch(
    payload,
    `v1/leagues-official/step-11/${officialId}`,
  )
  return response.data
}

export const useUpdateOfficial = () => {
  const queryClient = useQueryClient()
  return useMutation(updateOfficial, {
    onSuccess: (updatedOfficial: OfficialConstraintResp) => {
      queryClient.setQueryData(
        ['get-league-officials-constraints'],
        (oldData: OfficialConstraintResp[] | undefined) => {
          if (!oldData) return []
          return oldData.map(official =>
            official._id === updatedOfficial._id ? updatedOfficial : official,
          )
        },
      )
    },
  })
}

// delete official
const deleteOfficial = async (officialId: string) => {
  const response = await axiosDelete(
    `v1/leagues-official/step-11/delete-by-id/${officialId}`,
  )
  return response.data
}
export const useDeleteOfficial = () => {
  const queryClient = useQueryClient()
  return useMutation(deleteOfficial, {
    onSuccess: (deletedOfficial: OfficialConstraintResp) => {
      queryClient.setQueryData(
        ['get-league-officials-constraints'],
        (oldData: OfficialConstraintResp[] | undefined) => {
          if (!oldData) return []
          return oldData.filter(
            official => official._id !== deletedOfficial._id,
          )
        },
      )
    },
  })
}
